import uiRouter from '@uirouter/angularjs';
import angular from 'angular';
import { MembershipRulesLifecycleView } from './lifecycle/lifecycle';

export const MembershipRulesView = angular
  .module('acme.view.application.membership.rules', [
    uiRouter,
    'ui.bootstrap',
    'acme.view.application.membership.rules.controllers',
    'acme.view.application.membership.rules.updowngrade',
    MembershipRulesLifecycleView
  ])
  .config(function config($stateProvider) {
    // Create both abstract view and template view.
    // Abstract Views are enabled by default
    const membershipRules = {
      name: 'application.membership.rules',
      url: '/rules',
      abstract: true,
      views: {
        'subview-main': {
          controller: 'MembershipRulesController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/membership/rules/rules.tpl.html',
        },
      },
      data: {
        pageTitle: 'Membership Rules',
        /** Secure With Permissions **/
        permissions: ['MEMBERSHIP_RULES_VIEW'],
      },
    };

    $stateProvider.state(membershipRules);
  }).name;
